import React, { useState } from 'react';
// @ts-ignore
import IntlTelInput from 'intl-tel-input/reactWithUtils';
import { Description, Input, Label } from '@headlessui/react';
import { FormField } from '../../types/components';

export default function PhoneField({
  field,
  response,
}: { field: FormField, response: any }) {
  const [country, setCountry] = useState<string>('nl');
  const [number, setNumber] = useState<string>('');

  return (
    <div className="w-full phone-field">
      <label htmlFor={field.handle} className="mb-2">{field.label}</label>
      {field.countryEnabled ? (
        <>
          <IntlTelInput
            onChangeNumber={setNumber}
            onChangeCountry={setCountry}
            initOptions={{
              initialCountry: 'nl',
              separateDialCode: true,
              autoPlaceholder: 'off',
              formatOnDisplay: true,
              formatAsYouType: true,
            }}
            inputProps={{
              placeholder: field.placeholder,
              required: field.required,
              id: field.handle,
            }}
          />
          <input type="hidden" value={country} name={`fields[${field.handle}][country]`} />
          <input type="hidden" value={number} name={`fields[${field.handle}][number]`} />
        </>
      ) : (
        <>
          <Label className="mb-2">
            {field.label}
            {field.required && (
              <span className="ml-1 text-accent">*</span>
            )}
          </Label>
          <Input
            type={field.fieldType}
            name={`fields[${field.handle}]`}
            placeholder={field.placeholder}
            required={field.required}
            className={response && Object.prototype.hasOwnProperty.call(response.errors, field.handle) ? '!border-accent' : ''}
          />
          {response
            && Object.prototype.hasOwnProperty.call(response.errors, field.handle) && (
              <Description className="text-accent">{response.errors[field.handle][0]}</Description>
          )}
        </>
      )}
    </div>
  );
}
